import React from 'react';
import { isInclusivelyBeforeDay } from 'react-dates';

import './presets.scss';
import { getClass } from '../../../utils/component-helpers';

export default props => {
  function isEnabled(key) {
    if (!props.disablePastDates && props.allowFutureDates) return true;

    const pastThreshold = props.pastDateThreshold;
    const futureThreshold = props.futureLimit;

    const past = pastThreshold ? props.presetRanges[key].startDate.isAfter(pastThreshold) : true;
    const future = futureThreshold
      ? isInclusivelyBeforeDay(props.presetRanges[key].endDate, props.futureLimit)
      : true;

    return past && future;
  }

  function onPresetClick(key) {
    if (isEnabled(key)) {
      props.presetClicked(key);
    }
  }

  const options = (
    <div className="options">
      <button className="apply-btn" onClick={() => props.apply()}>
        Apply
      </button>
      <button className="cancel-btn" onClick={() => props.cancel()}>
        Cancel
      </button>
    </div>
  );

  const { presetRanges } = props;
  const datePresets = (
    <div className="date-presets">
      {Object.keys(presetRanges).map(key => {
        return (
          <button
            key={key}
            className={getClass('preset', {
              selected: presetRanges[key].selected,
              disabled: !isEnabled(key),
            })}
            onClick={() => onPresetClick(key)}
          >
            {presetRanges[key].label}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className="date-picker-presets">
      {options}
      {datePresets}
    </div>
  );
};
